<template>
    <!-- <div class="a-facility" v-if="($route.name === 'task' && !isTemplate || $route.name === 'taskid') && permissions.tasks.enabled"> -->
    <div class="a-facility" v-if="treeList.length > 0">
        <button class="a-facility__toggle" v-if="facilityVisible" @click="facilityToggle($event)">
            <icon name="location" class="large-svg fill-white" />
            Kort
        </button>
        <button class="a-facility__toggle" v-else @click="facilityToggle($event)">
            <icon name="asset" class="large-svg fill-white" />
            Anlægsregister
        </button>

        <div class="a-facility__wrapper" v-if="facilityVisible">
            <div class="a-facility__node" v-if="treeSelected">
                <div style="grid-column: span 2;">
                    <button @click="treeClear($event)" style="color: #fff;">
                        <icon name="arrow-left-circle" class="medium-svg fill-white" style="margin-right: 12px; vertical-align: middle;" />
                        <icon name="building" class="small-svg fill-white" style="margin-right: 4px; vertical-align: middle;" />
                        {{ treeSelected.name }}
                    </button>
                </div>
                <div class="a-facility__spinner" v-if="nodeListLoading">
                    <div class="a-facility__loader">
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="visually-hidden">Indlæser liste med emner...</div>
                    </div>

                </div>
                <template v-else>
                    <node-tree class="node__list" ref="baseTree" :data="nodeList" :options="nodeListOptions" @node:expanded="onNodeExpanded" @node:selected="onNodeSelected" @node:checked="onNodeChecked" @node:unchecked="onNodeChecked">
                        <template slot-scope="{ node }">
                            <span class="node__text">
                                {{ node.text }}
                                <template v-if="node.data.geomWkt">
                                    <svg class="node__location" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" width="24" height="24">
                                        <path fill="#fff" d="M50,2.5c-17.8,0-32.2,14.4-32.2,32.2c0,12.7,16.3,42.7,25.7,59c2.9,5,10.1,5,13,0c9.4-16.3,25.7-46.4,25.7-59C82.2,16.9,67.8,2.5,50,2.5z M50,53.1c-10.1,0-18.4-8.2-18.4-18.4c0-10.1,8.2-18.4,18.4-18.4c10.1,0,18.4,8.2,18.4,18.4C68.4,44.9,60.1,53.1,50,53.1z"/>
                                    </svg>
                                </template>
                                <template v-if="node.text === '' && nodeChildrenLoading">
                                    <svg class="node__spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                        <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="4" stroke-dasharray="16 16" fill="none"/>
                                        <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="4" fill="none" opacity="0.2"/>
                                    </svg>
                                </template>
                            </span>
                        </template>
                    </node-tree>
                    <div class="node__info">
                        <div class="asset-user-feedback" v-if="facilityState === 'added'">
                            <div class="asset-user-feedback-checkmark">
                                <icon name="checkmark" class="big-svg fill-white" />
                            </div>
                            <div>Emne tilknyttet</div>
                        </div>
                        <div v-else>
                            <template v-if="this.nodeSelected">
                                <h2>{{ nodeSelected.data.name }}</h2>

                                <template v-if="nodeTemplatePropertiesSorted.length > 0" v-for="prop in nodeTemplatePropertiesSorted">
                                    <div class="property-group" v-if="prop.type === 'group'" :key="prop.data.nodePropertyTemplateId">
                                        <div class="property-group__heading">{{ prop.data.name }}</div>
                                        <div class="property-group__item">
                                            <dl v-for="groupProp in prop.data.properties" class="node__property-list">
                                                <dt>{{ groupProp.name }}</dt>
                                                <dd v-html="propertyValueGet(groupProp)"></dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <dl v-else class="node__property-list">
                                        <dt>{{ prop.data.name }}</dt>
                                        <dd v-html="propertyValueGet(prop.data)"></dd>
                                    </dl>
                                </template>
                                <template v-else>
                                    <p style="text-align: center;"><em>Ingen oplysninger</em></p>
                                </template>
                            </template>
                            <template v-else>
                                <h2>Kryds emner af i listen under "{{ treeSelected.name }}"</h2>

                                <p v-if="nodesChecked.length > 0" style="text-align: center;">Antal valgte emner: {{ nodesChecked.length }}</p>

                                <ol>
                                    <li v-for="node in nodesChecked">
                                        {{ node.text }}<br />
                                        <template v-if="node.data.path"><small>(<em>{{ node.data.path }}</em>)</small></template><br />
                                    </li>
                                </ol>
                            </template>
                        </div>

                        <div>
                            <button class="button button-long button-primary" :disabled="this.activityIdList.length === 0 || nodesChecked.length === 0" @click="onNodesAdd(false)">Tilknyt emner</button>
                        </div>
                    </div>
                </template>
            </div>
            <div class="a-facility__tree" v-else>
                <div class="a-facility__spinner" v-if="treeListLoading">
                    <div class="a-facility__loader">
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="a-facility__bar"></div>
                        <div class="visually-hidden">Indlæser liste med træer...</div>
                    </div>
                </div>
                <template v-else>
                    <h2>Vælg anlægsregister</h2>
                    <ul class="tree__list">
                        <li class="tree__item" v-for="tree in treeList" :key="tree.treeId">
                            <button class="tree__button" @click="treeSelect($event, tree.treeId)">
                                <icon name="building" class="smaller-svg" />
                                {{ tree.name }}
                            </button>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
    <!-- </div> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LiquorTree from 'liquor-tree'
import formatDate from '@/mixins/shared/formatDate.js'
import formatText from '@/mixins/shared/formatText.js'
import axios from '@/store/api.js'

export default {
    name: 'TheFacilityTree',
    components: {
        'node-tree': LiquorTree
    },
    mixins: [formatDate, formatText],
    props: {
        visible: {
            Object: Boolean,
            default: false
        }
    },
    data () {
        return {
            facilityState: 'initial',
            facilityVisible: this.visible,
            treeListLoading: false,
            treeList: [],
            treeSelected: null,
            treeRootName: null,
            templateList: [],
            nodeListLoading: false,
            nodeList: [],
            nodeChildrenLoading: false,
            nodeListOptions: {
                checkbox: true,
                multiple: false,
                parentSelect: true,
                autoCheckChildren: false
            },
            nodeSelected: null,
            nodesChecked: []
        }
    },
    computed: {
        ...mapGetters({
            isTemplate: 'getTaskTemplate',
            permissions: 'permissions',
            selectedActivities: 'getSelectedActivities'
        }),

        activityIdList () {
            if (this.selectedActivities.length > 0) {
                return this.selectedActivities.filter(activity => activity.selected).map(activity => activity.activityId)
            }
            return []
        },

        activityCodeList () {
            if (this.nodesChecked.length > 0) {
                return this.nodesChecked.map(node => node.activityCodeList)
            }
            return []
        },

        nodeTemplatePropertiesSorted () {
            if (this.nodeSelected) {
                const template = this.templateList.find(template => template.nodeTemplateId === this.nodeSelected.data.nodeTemplateId)

                if (template) {
                    const combined = []

                    if (template.properties) {
                        template.properties.forEach(property => {
                            combined.push({ type: 'normal', data: property, sortOrder: property.sortOrder })
                        })
                    }
                    if (template.propertyGroups) {
                        template.propertyGroups.forEach(group => {
                            combined.push({ type: 'group', data: group, sortOrder: group.sortOrder })
                        })
                    }

                    return combined.sort((a, b) => {
                        if (a.sortOrder < b.sortOrder) {
                            return -1
                        }
                        if (a.sortOrder > b.sortOrder) {
                            return 1
                        }
                        return 0
                    })
                }
            }

            return []
        }
    },
    created () {
        this.treeListLoading = true
        axios.get('/DriveFacility/GetTreeList')
            .then((response) => {
                this.treeList = response.data
                this.treeListLoading = false
            })
            .catch((error) => {
                console.error('error', error)
                this.treeListLoading = false
            })
    },
    methods: {
        ...mapActions({
            setTaskObjectList: 'setTaskObjectList'
        }),

        facilityToggle (event) {
            this.facilityVisible = !this.facilityVisible
            if (!this.facilityVisible) {
                this.nodesSelected = null
                this.nodesChecked = []
            } else {
                this.treeNodesGet()
            }
            this.$emit('facilityVisible', this.facilityVisible)
        },

        treeSelect (event, treeId) {
            this.treeSelected = this.treeList.find(tree => tree.treeId === treeId)
            this.treeNodesGet()
            this.$emit('treeSelected', this.treeSelected)
        },
        treeClear (event) {
            this.treeSelected = null
            this.treeRootName = null
            this.nodesSelected = null
            this.nodesChecked = []
            this.$emit('treeSelected', this.treeSelected)
        },

        treeNodesGet () {
            if (this.treeSelected) {
                this.nodeListLoading = true

                const requestData = {
                    treeId: this.treeSelected.treeId,
                    parentNodeId: null,
                    includeChildNodes: false,
                    includeNodeTemplates: true
                }
                axios.post('/DriveFacility/GetFacilityTree', requestData)
                    .then((response) => {
                        if (response.data.success) {
                            this.treeRootName = response.data.model.name
                            this.templateList = response.data.model.nodeTemplates
                            this.nodeList = response.data.model.rootNode.childNodes.map(node => this.formatNode(node))
                        } else {
                            throw new Error('Fejl ved hentning af trænoder')
                        }
                    })
                    .then(() => {
                        this.nodeListLoading = false
                        this.nodeChildrenLoading = false
                    })
                    .catch((error) => {
                        console.error('error', error)
                        this.nodeListLoading = false
                        this.nodeChildrenLoading = false
                    })
            }
        },
        childNodesGet (parentNode) {
            if (parentNode.data.hasChildNodes) {
                this.nodeChildrenLoading = true

                const requestData = {
                    treeId: this.treeSelected.treeId,
                    parentNodeId: parentNode.data.nodeId,
                    includeChildNodes: false,
                    includeNodeTemplates: false
                }
                axios.post('/DriveFacility/GetFacilityTree', requestData)
                    .then((response) => {
                        if (response.data.success) {
                            if (parentNode.children[0] && parentNode.children[0].text === '') {
                                parentNode.children[0].remove() // Remove pseudo child
                            }
                            response.data.model.rootNode.childNodes.forEach((node) => {
                                parentNode.append(this.formatNode(node, parentNode))
                            })
                        } else {
                            throw new Error('Fejl ved hentning af trænoder')
                        }
                    })
                    .then(() => {
                        this.nodeChildrenLoading = false
                    })
                    .catch((error) => {
                        console.error('error', error)
                        this.nodeChildrenLoading = false
                    })
            }
        },
        formatNode (node, parent) {
            const nodeObject = {}

            nodeObject.id = node.nodeId
            nodeObject.text = node.name
            nodeObject.children = []
            if (node.hasChildNodes) {
                nodeObject.children.push({ id: '', text: '', children: [], data: '' })
            }
            nodeObject.data = node
            nodeObject.data.path = this.treeRootName
            if (parent) {
                let nodePath = this.getAncestors(parent).map(node => node.data.name).join(' > ')

                nodeObject.data.path += ` > ${nodePath}`
            }

            return nodeObject
        },

        propertyValueGet (templateProperty) {
            let property = this.nodeSelected.data.properties.find(p => p.nodePropertyTemplateId === templateProperty.nodePropertyTemplateId)
            if (!property) {
                const group = this.nodeSelected.data.propertyGroups.find(g => g.properties.find(p => p.nodePropertyTemplateId === templateProperty.nodePropertyTemplateId))
                if (!group) {
                    return null
                }
                property = group.properties.find(p => p.nodePropertyTemplateId === templateProperty.nodePropertyTemplateId)
                if (!property) {
                    return null
                }
            }
            if (templateProperty.dataType === 'bool') {
                return property.value ? 'Ja' : 'Nej'
            } else if (templateProperty.dataType === 'hyperlink' && property.hyperlinkTextToDisplay) {
                return this.formatHyperlink(property.value, property.hyperlinkTextToDisplay)
            } else if ((property.value || property.valueListItemId) && property) {
                let value = property.value

                if (templateProperty.dataType === 'datetime') {
                    value = this.formatDate(value)
                } else if (templateProperty.dataType === 'hyperlink') {
                    value = this.formatHyperlink(value, property.hyperlinkTextToDisplay)
                } else if (templateProperty.dataType === 'listitem') {
                    value = templateProperty.valueList.find(item => item.nodePropertyValueListItemId === property.valueListItemId).value
                } else if (templateProperty.dataType === 'integer' || templateProperty.dataType === 'decimal') {
                    value = value.toLocaleString('da-DK')
                }

                if (templateProperty.unitOfMeasurement) {
                    return `${value} ${this.formatSuffix(templateProperty.unitOfMeasurement)}`
                }

                return value
            }

            return null
        },

        getAncestors (item, ancestors = []) {
            ancestors.unshift(item)
            if (item.parent) {
                const found = this.getAncestors(item.parent, ancestors)

                if (found) {
                    return found
                }
            }
            return ancestors
        },

        onNodeExpanded (node) {
            if (node.children.length === 1 && node.children[0].text === '') {
                this.childNodesGet(node)
            }
        },
        onNodeSelected (node) {
            if (node.tree.activeElement) {
                this.nodeSelected = node
                this.$emit('nodeSelected', this.nodeSelected)
            }
        },
        onNodeChecked (node) {
            this.nodeSelected = null
            this.nodesChecked = node.tree.checkedNodes
        },
        onNodesAdd (createActivities) {
            if (this.$store.state.task.selectedTask.taskId) {
                this.facilityState = 'adding'
                this.nodesChecked.forEach((node) => {
                    const requestData = {
                        taskId: this.$store.state.task.selectedTask.taskId,
                        activityIdList: this.activityIdList,
                        nodeId: node.data.nodeId
                    }
                    axios.post('/TaskActivity/AddFacilityObjectToActivities', requestData)
                        .then(async (response) => {
                            await this.setTaskObjectList(this.$store.state.task.selectedTask.taskId)
                            this.$emit('nodesAdd', response.data)
                            this.facilityState = 'added'
                            setTimeout(() => {
                                this.facilityState = 'initial'
                            }, 3000)
                        })
                        .catch((error) => {
                            console.error('error', error)
                        })
                })
            }
        }
    }
}
</script>

<style lang="scss">
:root {
    --facilityButtonBackgroundColor: #fff;
    --facilityButtonShadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    --facilityButtonIconColor: #333;
    --facilityButtonBackgroundColorHover: #5293bc;
    --facilityButtonTextColorHover: #fff;
    --facilityButtonIconColorHover: #fff;

    --ease-in-out-cubic: cubic-bezier(0.645, 0.045, 0.355, 1); /* https://cubic-bezier.com/#0.645,0.045,0.355,1 */
}

.a-facility {
    height: 0;
    width: 0;

    h2 {
        margin-bottom: 24px;
    }

    &__toggle {
        background: #2c3e50;
        border-radius: 3px;
        box-shadow:
            0 14px 28px rgba(0, 0, 0, 0.25),
            0 10px 10px rgba(0, 0, 0, 0.22);
        color: #fff;
        line-height: 1.5em;
        min-width: 80px;
        padding: 6px 12px;
        position: absolute;
        right: 12px;
        top: 25px;
        z-index: 11;

        .icon {
            display: block;
            margin: 2px auto;
        }
    }
    &__wrapper {
        background-color: #393939;
        color: #fff;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        width: calc(100% - 40px);
        z-index: 10;
    }
    &__tree {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        padding: 36px;
    }
    &__node {
        display: grid;
        grid-template-columns: minmax(240px, 550px) calc(60% - 12px);
        grid-template-rows: min-content 1fr;
        gap: 36px 24px;
        height: 100%;
        padding: 36px;
    }

    &__spinner {
        align-items: center;
        display: flex;
        grid-column: span 2;
        justify-content: center;
    }

    &__loader {
        margin: 2em auto;
        width: 4em;
    }
    &__bar {
        animation: swiper 4s infinite var(--ease-in-out-quad);
        animation-fill-mode: both;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 15%, transparent 15%, transparent 30%, rgba(255, 255, 255, 0.5) 30%, rgba(255, 255, 255, 0.5) 100%);
        height: 0.5em;
        margin-bottom: 0.25em;
        margin-top: 0.25em;
        width: 100%;

        &:nth-child(2) {
            animation-delay: 0.3s;
            margin-left: 0.5em;
        }
        &:nth-child(3) {
            animation-delay: 0.8s;
            margin-left: 1em;
        }
        &:nth-child(4) {
            animation-delay: 1s;
            margin-left: 0.5em;
        }
    }
}

@keyframes swiper {
    0% {
        opacity: 0;
        transform: translateX(-40%);
    }
    3.75% {
        opacity: 0;
    }
    15% {
        opacity: 1;
    }
    22.5%,
    52.5% {
        opacity: 1;
        transform: translateX(0);
    }
    60% {
        opacity: 1;
    }
    71.25% {
        opacity: 0;
    }
    75%,
    100% {
        opacity: 0;
        transform: translateX(40%);
    }
}

.tree__list {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 24px;
}
.tree__item {
}
.tree__button {
    background: var(--facilityButtonBackgroundColor);
    box-shadow: var(--facilityButtonShadow);
    border-radius: 3px;
    color: #424242;
    line-height: 1.5em;
    padding: 12px 36px;
    transition: background 0.15s var(--ease-in-out-cubic), color 0.15s var(--ease-in-out-cubic);

    .icon {
        fill: var(--facilityButtonIconColor);
        margin-bottom: 2px;
        margin-right: 4px;
        transition: fill 0.15s var(--ease-in-out-cubic);
        vertical-align: middle;
    }

    &:hover,
    &:focus {
        background: var(--facilityButtonBackgroundColorHover);
        color: var(--facilityButtonTextColorHover);

        .icon {
            fill: var(--facilityButtonIconColorHover);
        }
    }
}

.node__list {
    background: #444;
    height: 100%;
    overflow: auto;

    .tree-content {

        &:has(.node__spinner) .tree-checkbox {
            opacity: 0;
            pointer-events: none;
        }
        .tree-arrow.has-child:after {
            border-color: white;
        }
        .tree-anchor {
            color: white;

            .node__location {
                margin-left: 6px;
                transform-origin: 50% 100%;
                transition: transform 0.4s ease-out;
                vertical-align: middle;
            }
            .node__spinner {
                animation: loop 0.8s linear infinite;
                margin-left: calc(3px - 30px - 3px - 6px);
                vertical-align: middle;
            }
        }

        &:hover {

            .tree-arrow.has-child:after {
                border-color: #424242;
            }
            .tree-anchor {
                color: #424242;

                .node__location {
                    transform: rotate(15deg);

                    path {
                        fill: #333;
                    }
                }
            }
        }
    }
    .selected .tree-content {

        .tree-arrow.has-child:after {
            border-color: #424242;
        }
        .tree-anchor {
            color: #424242;

            svg path {
                fill: #333;
            }
        }
    }
}
.node__item {
}
.node__button {
    background: #fff;

    border-radius: 3px;
    color: #424242;
    display: block;
    padding: 12px 36px;
    width: 100%;
}
.node__info {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    margin-left: auto;
    max-width: 540px;
    overflow: auto;
    padding-left: 18px;
    padding-right: 18px;
    width: 100%;

    h2 {
        margin-top: 36px;
        text-align: center;
    }
}
.node__property-list {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    font-size: 1.1rem;
    gap: 1.5em;
    line-height: 1.5em;
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: 8px;
    padding-top: 8px;

    & + & {
        margin-top: -1px;
    }

    dt {
        font-weight: 700;
        margin-bottom: 0;
        min-width: 180px;
    }
    dd {
        font-weight: 600;
        margin-left: 0;
    }
}

.property-group {
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid #d6d6d8;
    margin: 24px -18px 18px -18px;
    padding: 0 17px 12px 17px;

    &__heading {
        background: #5293bc;
        border-radius: 3px;
        display: inline-block;
        font-weight: 500;
        padding: 0.25em 1em;
        transform: translate(-6px, -10px);
    }
    &__item {
        margin-bottom: 0.5em;
        margin-top: 0.5em;
    }
}
.asset-user-feedback {
  opacity: 0;
  animation-name: bounceIn;
  animation-duration: 450ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .asset-user-feedback-checkmark {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      border: 7px solid white;
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      margin-bottom: 25px;
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3) translate3d(0,0,0);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.1);
  }
  80% {
    opacity: 1;
    transform: scale(0.89);
  }
  100% {
    opacity: 1;
    transform: scale(1) translate3d(0,0,0);
  }
}
@keyframes loop {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TheFacilityTree.vue